/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
<template>
    <div class="bgView">
        <div class="infoView">
            <div class="infoView-top">
                <div class="iconView fl">
                    <div class="imageView">
                        <span v-if="userData.avatar == 'null'||userData.avatar == null">
                        <img src="../../../assets/images/avatar.png" alt="">
                        </span>
                        <span v-else>
                        <img :src="userData.avatar" alt="">
                        </span>
                        <!-- 头像 -->
                    </div>
                    <div class="change-icon">
                        <a href="javascript:void(0);" @click="uploadeToQiniu()">更换头像</a>
                        <!-- accept="image/gif, image/jpeg, image/png, image/bmp" -->
                        <input type="file" id="userPic" @change="uploadeToQiniu()" accept="image/png,image/jpeg" style="opacity:0;">
                        
                    </div>
                </div>
                <div class="userInfo-View fl">
                    <div class="userInfo-View-username">
                        <span>姓名：</span>
                        <div class="userInfo_input">
                        <!-- <el-input v-html="userData.studentName"  placeholder="请输入姓名"></el-input> -->
                            <el-input v-model="userData.studentName"  placeholder="请输入姓名"></el-input>
                        </div>
                    </div>
                    <div class="userInfo-View-nickName">
                        <span>昵称：</span>
                        <div class="userInfo_input">
                            <el-input v-model="userData.nickName" placeholder="请输入昵称"></el-input>
                        </div>
                    </div>
                    <div class="userInfo-View-sex">
                        <span>性别：</span>
                        <div class="userInfo_input">
                            <el-radio class="radio" v-model="userData.gender"  label="1">男</el-radio>
                            <el-radio class="radio" v-model="userData.gender" label="2">女</el-radio>
                        </div>
                    </div>
                    <div class="userInfo-View-location">
                        <span>地区：</span>
                        <div class="userInfo_input">
                        <div class="userInfo_input_select">
                        <!-- userData.provinceName userData.cityName -->
                            <el-select v-model="userData.province" placeholder="省" @change="selectedProvince">
                                <el-option v-for="provinceModel in provinceList" :label="provinceModel.provinceName" :key="provinceModel.provinceId" :value="provinceModel.provinceId">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="userInfo_input_select">
                            <el-select v-model="userData.cityName" placeholder="市" @change="selectedClity">
                                <el-option v-for="cityModel in cityList" :label="cityModel.cityName" :value="cityModel.cityId" :key="cityModel.cityId">
                                </el-option>
                            </el-select>
                        </div>
                        </div>  
                    </div>
                    <div class="userInfo-View-phone">
                        <span>手机：</span>
                        <div class="userInfo_input">
                            <el-input v-model="userData.username" placeholder="请输入手机号" :disabled="true"></el-input>
                        </div>
                    </div>
                    <!-- <div class="userInfo-View-mail">
                        <span>邮箱：</span>
                        <div class="userInfo_input">
                        <el-input placeholder="请输入邮箱"></el-input>
                        </div>
                    </div> -->
                    </div>
            </div>
            <div class="infoView-bottom">
                <div class="bottom-title">其他信息</div>  
                <div class="bottom-selectview">
                <div class="bottom-selectview-content">
                    <div class="fl" style="width:300px;">
                    <span>级别：</span>
                    <div class="userInfo_input_select">
                        <el-select v-model="userData.junior" placeholder="年段" @change="selectJunior">
                            <el-option v-for="yearModel in yearlist" :key="yearModel.value" :label="yearModel.label" :value="yearModel.value">
                            </el-option>
                        </el-select>
                    </div>
                    </div>
                    <!--<div class="fl">
                    <span>科目：</span>
                    <div class="userInfo_input_select">
                        <el-select v-model="userData.subjectId" placeholder="科目" @change="selectSubject">
                        <el-option v-for="subject in subjectList" :label="subject.label" :value="subject.value">
                        </el-option>
                        </el-select>
                    </div>
                    </div> -->
                </div>
                </div>
               
                <div class="bottom-button">
                    <div class="bottom-button-a">
                        <a href="javascript:void(0);" class="btn-orange" @click="backToPersonal">取消</a>
                    </div>
                    <div class="bottom-button-a">
                        <a href="javascript:void(0);" class="btn-default" @click="updateUserInfo">保存</a>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
export default {
    data(){
        return {
            userData:{},         //用户信息
            provinceList:[],
            cityList:[],
             yearlist:[
                {label: '预备级',value: 0},
                {label: '一级',value: 1},
                {label: '二级',value: 2},
                {label: '三级',value: 3},
                {label: '四级',value: 4},
                {label: '五级',value: 5},
                {label: '六级',value: 6}
            ],
            value1:0,
            value2:'1',
            radio:'1',
            gender:'1',
            token:'',
            // 用户属性
            // gender:'',
            province:0,
            city:0,
            nickName:'',
            avatar:'',
            studentName:'',
            junior:'',
            subjectId:'',
            userPostData:{},
            isFrist:true,
            upLoadToken:''
        }
    },
    created () {
        this.getAreaProvince();

        this.getUserInfo();  
    },
    methods:{
        uploadeToQiniu(){
            //mOxie
            // /user/center/obtainQiNiuToken
            var self = this
            // console.log(this.token) 
            qiniu.uploader({
                runtimes: 'html5,flash,html4',
                browse_button: 'userPic',
                max_file_size: '10mb',
                uptoken:this.token,
                unique_names: false,
                save_key: false,
                chunk_size: '4mb',
                domain: 'http:/image.xueyoubangbang.com/',
                get_new_uptoken: true,
                auto_start: true,
                max_retries:2,
                log_level: 5,
                init: {
                    'FileUploaded': function(up, file, info) {
                    var objInfo = JSON.parse(info)
                    self.upAvatarData(objInfo.key)
                    },
                    // eslint-disable-next-line no-unused-vars
                    'Key': function(up, file) {
                    var key = Date.parse(new Date()) +'_'+localStorage.userId;
                    return key
                    },
                    // eslint-disable-next-line no-unused-vars
                    'Error': function(up, err, errTip) {
                    //上传出错时，处理相关的事情
                        self.$alert('上传发生错误,请重新尝试')
                    },
                }
            });
        },
        //获取所有省
        getAreaProvince: function() {
            
            let apiUrl = this.baseUrl()+"/mobile/user/obtainAreaProvince";

            let params ={
                userId: localStorage.userId,
                token: localStorage.token
            }

            this.$http.post(apiUrl,       // 还可以直接把参数拼接在url后边
				this.$qs.stringify(params),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
			).then(function(res){
                this.provinceList = res.data.data.tbAreaProvinces
                var provinceArray = []
                for(var i = 0;i<this.provinceList.length;i++){
                    var provinceModel = this.provinceList[i]
                    provinceModel = Object.assign({},provinceModel,{isOk:true})
                    provinceArray.push(provinceModel)
                }
                this.provinceList = provinceArray
                

			}).catch(function (error) {
				console.log(error);
			});

        },
        //根据省id 获取市
        getAllCitys: function(proviceId){
            // console.log(proviceId)
            //this.requestData('/mobile/user/obtainAreaProvince',{proviceId:proviceId},2)
            let apiUrl = this.baseUrl()+"/mobile/user/obtainAreaProvince";

            let params ={
                proviceId:proviceId
            }

            this.$http.post(apiUrl,       // 还可以直接把参数拼接在url后边
				this.$qs.stringify(params),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
			).then(function(res){
                this.cityList = res.data.data.citys
                var cityArray = []
                for(var i = 0;i<this.cityList.length;i++){
                var cityModel = this.cityList[i]
                cityModel = Object.assign({},cityModel,{isOk:true})
                cityArray.push(cityModel)
                }
                this.cityList = cityArray
                // console.log(this.cityList)
                if(this.cityList.length != 0){
                let cityModel = this.cityList[0]
                this.selectedClity(cityModel.cityId)
                this.userData.cityName = cityModel.cityName
                }
                

			}).catch(function (error) {
				console.log(error);
			});
        },
        selectedClity: function(index){
            //cityId
            // console.log(index)
            if(index != null){
                
                this.city = index
                if(this.isFrist == true){
                this.isFrist = false
                return
                }
                // console.log(index)
                if(typeof(index) == 'string'){
                return
                }
                this.userData.city = index
                //this.userData.cityName = 
            }
        },
        selectedProvince: function(index){
            if(index != null){
                this.province = index
                this.getAllCitys(index)
            }
        },
         selectJunior(value){
            // console.log(value)
            this.junior = value
        },
        //获取用户信息
        getUserInfo(){

            let apiUrl = this.baseUrl()+"/mobile/teacher/getStudentBaseInfo";

            let params ={
                userId: localStorage.userId,
                token: localStorage.token
            }

            this.$http.post(apiUrl,       // 还可以直接把参数拼接在url后边
				this.$qs.stringify(params),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
			).then(function(res){
				this.userData = res.data.data
                this.userData.studentName = decodeURIComponent(this.userData.studentName)
                this.userData.nickName = decodeURIComponent(this.userData.nickName)
                this.gender = String(this.userData.gender)
                localStorage.avatar = res.data.data.avatar
                localStorage.nickName = res.data.data.nickName
                
                
				console.log(res.data.data);

			}).catch(function (error) {
				console.log(error);
			});

        },
        backToPersonal: function() {
            this.$router.push('/personalCenter')
        },
        updateUserInfo: function () {
            if(this.gender == 'null'){
                this.gender = '1'
            }
            this.userData.gender = this.gender
            //this.requestData('/mobile/user/saveTeacherUser',this.userData,3)

            let apiUrl = this.baseUrl()+"/mobile/user/saveTeacherUser";

            this.$http.post(apiUrl,       // 还可以直接把参数拼接在url后边
				this.$qs.stringify(this.userData),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
			).then(function(res){

                if(res.data.flag == 0){
                    return
                }

				// localStorage.avatar = successResp.body.data.avatar
                localStorage.nickName = this.userData.nickName
                this.$alert('保存成功', '提示', {
                confirmButtonText: '确定',
                callback:{
                    // this.$router.push('/personalCenter/mylession')
                }
                });
                
                
				console.log(res.data.data);

			}).catch(function (error) {
				console.log(error);
            });
            
            //此gender非彼gender，冒充年段使用，不要乱改
            
            localStorage.gender = this.junior
        },
    }
}
</script>

<style scoped>
    .bottom-selectview-content .el-input{
        width: 160px;
    }
    .bottom-selectview-content .el-input__inner{
        width: 160px;
    }
    .bgView {
        margin: 0 auto;
        width: 100%;
        background: #f7f7f7;
    }
    .infoView {
        margin: 0 auto;
        width: 840px;
    }
    .infoView span {
        color: #262626;
    }

    .infoView-top {
        width: 100%;
        height: 300px;
        background: white;
    }

    /*左侧内容*/
    .iconView {
        width: 420px;
        height: 150px;
        margin-top: 35px;
    }

    .imageView {

        text-align: center;
        width: 150px;
        height: 150px;
        margin: 0 auto;
        border-radius:75px;
        overflow: hidden;
    }
    .imageView img {
        width: 100%;
        height: 100% ;
    }
    .change-icon {
        width: 420px;
        /*height: 100px;*/
        /*background: blue;*/
        text-align: center;
        margin-top: 10px;
        position: relative;
    }
    .change-icon a {
        display: inline-block;
        border:1px solid #dfdfdf;
        color: #333;
        padding: 5px 10px;
        background: white;
    }
    .change-icon input{
        /*width:100%;*/
        height: 100%;
        position: absolute;
        top: 0;
        right: 30px;
        z-index: 2;
        opacity: 0;
        cursor:pointer;
    }
    /*右侧内容*/
    .userInfo-View {
        padding: 10px 0;
        width: 420px;
    }
    .userInfo_input {
        padding:10px 0;
        width: 225px;
        display: inline-block;
        vertical-align: middle;
    }
    .userInfo_input_select{
        /*width: 92px;*/
        width: 105px;
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
    }
    .userInfo-View-location .userInfo_input_select:last-child{
        margin-right: 0;
    }
    .userInfo-View span {
        width: 80px;
    /*line-height: 30px;*/
    /*vertical-align: middle;*/
    }
    .userInfo-View el-input {
        width: 100px;
    }
    /*底部视图*/
    .infoView-bottom {
        margin-top: 20px;
        width: 100%;
        height: 260px;
        background: white;
    }
    .bottom-title {
        padding: 30px 20px;
    }
    .bottom-selectview {
        margin:0 auto;
        height: 40px;
        padding:0 100px;
    }
    .bottom-selectview-content {
        height: 40px;
        display: inline-block;
    }

    .bottom-selectview-content .userInfo_input_select {
    /*width: 250px;*/
    }

    .bottom-schoolname{
        padding: 20px 100px;
    }
    .bottom-button {
        float: right;
    }
    .bottom-button-a{
        display: inline-block;
    }
    .bottom-button-a a{
        margin-right: 24px;
        margin-bottom: 10px;
        margin-top: 40px;
        padding: 5px 20px;
        color: #fff;
        border-radius: 2px;
        display: inline-block;
    }
    span {
        color: #262626;
    }
</style>